export const EDIT_VERSION_NAME_DESCRIPTION_MODAL = 'EDIT_VERSION_NAME_DESCRIPTION_MODAL';
export type Version = {
  id: string;
  versionBranchId: string;
  versionName?: string;
  versionDescription?: string;
  timestamp?: Date;
  owner?: string;
  hasBranchedDraft?: boolean;
};
